import { documentsConfiguration } from './application/documents';
import { checkAndSendConfiguration } from './application/checkAndSend';

export const applicationFormConfiguration = {
    documentsConfiguration: documentsConfiguration,
    checkAndSendConfiguration: checkAndSendConfiguration,
};
